<template>
  <RouterView />
</template>

<script setup lang="ts">
import SiteConfig from '@/SiteConfig'
import { fetchTranslations } from '@/Translations'
import { onMounted } from 'vue'

// Deliberately not awaited: a top-level await here would turn App into an
// async component and require a <Suspense> boundary. The shell renders
// immediately and the translations land reactively, as it did before.
fetchTranslations()

onMounted(() => {
  const favicon = document.querySelector<HTMLLinkElement>('link[rel*="icon"]')
  if (favicon) {
    favicon.href = SiteConfig.isWiB ? '/img/icons/favicon-wib-32x32.png' : '/img/icons/favicon-32x32.png'
  }
})
</script>
